import forEach from "lodash/forEach";
import { on } from "@rill/delegate";

const placeholderColor = "#ABABAB";

function updateSelectPlaceHolder(target) {
  requestAnimationFrame(() => {
    if (target.multiple) return;
    if (
      target.selectedIndex === 0 &&
      !target.options[target.selectedIndex].value
    ) {
      target.setAttribute("style", "color:" + placeholderColor);
      target.style.color = placeholderColor;
    } else {
      target.setAttribute("style", "");
    }
  });
}

const SelectPlaceholderController = async (app) => {
  app.use(async (ctx, next) => {
    on("change", "select", ({ target }) => updateSelectPlaceHolder(target));
    on("reset", "form", ({ target }) =>
      forEach(target.elements, (el) => {
        if (el.tagName === "SELECT") updateSelectPlaceHolder(el);
      })
    );

    await next();

    if (process.browser)
      requestAnimationFrame(() =>
        forEach(
          document.querySelectorAll("option:first-child[value='']:checked"),
          ({ parentNode }) => {
            if (parentNode.multiple) return;
            parentNode.style.color = placeholderColor;
          }
        )
      );
  });
};

export default SelectPlaceholderController;
